import { Box, BoxProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { CONTAINER_MAX_W, CONTAINER_PX } from '$shared/layout';

import { Footer } from './footer';
import { Header } from './header';

interface DefaultLayoutProps extends BoxProps {
  children: ReactNode;
}

export function DefaultLayout({ children, ...props }: DefaultLayoutProps) {
  return (
    <>
      <Header />

      <Box
        as="main"
        maxW={CONTAINER_MAX_W}
        mx="auto"
        px={CONTAINER_PX}
        pt={{ base: '24px', md: '40px' }}
        pb={{ base: '48px', md: '64px' }}
        {...props}
      >
        {children}

        <Footer />
      </Box>
    </>
  );
}
